import React from 'react'

import { ProblemaCondicaoModel } from '../../avaliacao/components/problemas-condicoes/model'
import { AsideSection } from '../AsideSection'
import { ProblemasCard } from './ProblemasCard'

export interface ProblemasSectionProps {
  prontuarioId: ID
  problemasAvaliados: ProblemaCondicaoModel[]
}

export function ProblemasSection(props: ProblemasSectionProps) {
  return (
    <AsideSection title='Lista de problemas/condições' type='clickable'>
      <ProblemasCard {...props} />
    </AsideSection>
  )
}
